<script lang="ts">
  export let selectedPageIndex: number;
  export let currentPageIndex: number;
  export let pagesLength: number;
  export let onAddPagesAbove: (e: Event) => void;
  export let onAddPagesBelow: (e: Event) => void;
  export let onSplicePage: () => void;
  export let onDeletePage: () => void;
  export let disabled: { splice: boolean; delete: boolean } = { splice: false, delete: false };

  import { clickOutside } from "./utils/clickOutside.js";
</script>

<style>
  .page-toolbar {
    /* Minimal one-bar design - no separate buttons */
    width: clamp(36px, 2.25vw, 42px);
    /* Maintain 30% from right edge */
    right: 30%;
    /* Top position: 25% from top + responsive offset (scales with viewport) */
    top: calc(25% + clamp(30px, 2.083vw, 40px));
    z-index: 00;
    padding: 0;
    transform: translateY(-50%);
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
  
  /* Seamless button sections - different colors */
  .toolbar-button {
    width: 100%;
    height: clamp(36px, 2.25vw, 42px);
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin: 0;
    padding: 0;
    transition: opacity 0.15s ease;
    cursor: pointer;
  }
  
  /* Add Above - Grey */
  .add-above-button {
    background-color: #edf2f7;
  }
  
  .add-above-button:hover {
    background-color: #6b7280;
  }
  
  /* Add Below - Grey */
  .add-below-button {
    background-color: #edf2f7;
  }
  
  .add-below-button:hover {
    background-color: #6b7280;
  }
  
  /* Splice - Grey */
  .splice-button {
    background-color: #edf2f7;
  }
  
  .splice-button:hover {
    background-color: #6b7280;
  }
  
  /* Delete - Red */
  .delete-button {
    background-color: #ef4444;
  }
  
  .delete-button:hover {
    background-color: #dc2626;
  }
  
  /* Icon styling - white icons on colored backgrounds */
  .toolbar-icon {
    font-size: clamp(16px, 1vw, 18px);
    font-weight: bold;
    color: #ffffff;
    line-height: 1;
  }
  
  .toolbar-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .toolbar-button:disabled:hover {
    opacity: 0.5;
  }

  @media (max-width: 767px) {
    .page-toolbar {
      right: 4px;
      left: auto;
      top: 42%;
      bottom: auto;
      transform: translateY(-50%);
      width: 36px;
      z-index: 25;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }

    .toolbar-button {
      height: 36px;
    }

    .toolbar-icon img {
      width: 16px;
      height: 16px;
    }
  }
</style>

<div
  class="page-toolbar fixed flex flex-col"
  data-testid="page-toolbar"
>
    <!-- Add Pages Above Button -->
    <label
      for="addPagesAbove-{currentPageIndex}"
      class="toolbar-button add-above-button"
      title="Add Pages Above"
    >
      <span class="toolbar-icon">
        <img
          alt="Add Above"
          src="up.png"
          style="width: 20px; height: 20px;"
         />
      </span>
    </label>
    <input
      type="file"
      id="addPagesAbove-{currentPageIndex}"
      name="addPagesAbove"
      accept="application/pdf"
      class="hidden"
      on:change={onAddPagesAbove}
    />
    
    <!-- Add Pages Below Button -->
    <label
      for="addPagesBelow-{currentPageIndex}"
      class="toolbar-button add-below-button"
      title="Add Pages Below"
    >
      <span class="toolbar-icon">        <img
        alt="Add Below"
        src="down.png"
        style="width: 20px; height: 20px;"
       /></span>
    </label>
    <input
      type="file"
      id="addPagesBelow-{currentPageIndex}"
      name="addPagesBelow"
      accept="application/pdf"
      class="hidden"
      on:change={onAddPagesBelow}
    />
    
    <!-- Splice Page Button -->
    <button
      on:click={onSplicePage}
      disabled={disabled.splice}
      class="toolbar-button splice-button"
      title="Splice Page"
    >
      <span class="toolbar-icon">        <img
        alt="Cut"
        src="cut.png"
        style="width: 20px; height: 20px;"
       /></span>
    </button>
    
    <!-- Delete Page Button -->
    <button
      on:click={onDeletePage}
      disabled={disabled.delete}
      class="toolbar-button delete-button"
      title="Delete Page"
    >
      <span class="toolbar-icon">        <img
        alt="Delete"
        src="delete_page.png"
        style="width: 20px; height: 20px;"
       /></span>
    </button>
</div>

